import { startOfWeek, endOfWeek, format } from 'date-fns';

const getOrdinalSuffix = (day: number): string => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const getCurrentWeekRange = (): string => {
  const now = new Date();
  const weekStart = startOfWeek(now, { weekStartsOn: 1 });
  const weekEnd = endOfWeek(now, { weekStartsOn: 1 });

  const startDay = weekStart.getDate();
  const endDay = weekEnd.getDate();
  const month = format(weekEnd, 'MMM');
  const year = weekEnd.getFullYear();

  if (weekStart.getMonth() === weekEnd.getMonth()) {
    return `${startDay}${getOrdinalSuffix(startDay)} - ${endDay}${getOrdinalSuffix(endDay)} ${month} ${year}`;
  }

  const startMonth = format(weekStart, 'MMM');
  return `${startDay}${getOrdinalSuffix(startDay)} ${startMonth} - ${endDay}${getOrdinalSuffix(endDay)} ${month} ${year}`;
};

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return format(date, 'EEEE do MMMM yyyy');
};

export const formatDateWithTime = (dateString: string): string => {
  const date = new Date(dateString);
  return `${format(date, 'EEEE do MMMM yyyy')} at ${format(date, 'HH:mm')}`;
};

export const formatShortDate = (dateString: string): string => {
  const date = new Date(dateString);
  return format(date, 'do MMM');
};

export const formatNextScheduledDate = (dateString: string): string => {
  const date = new Date(dateString);
  return format(date, 'EEEE do MMMM');
};

export const formatTime = (dateString: string): string => {
  const date = new Date(dateString);
  return format(date, 'HH:mm');
};
